import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../Context/UserContext";
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

const PaypalPaymentSuccess = () => {

  const { user } = useContext(UserContext);
  const [plan, setPlan] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const planParam = queryParams.get("plan");
    let planName = planParam === 'pro-weekly' ? 'Pro Weekly' : planParam === 'pro-monthly' ? 'Pro Monthly' : planParam === 'pro-yearly' ? 'Pro Yearly' : planParam === 'lifetime' ? 'Lifetime' : planParam;
    if (planParam){
      setPlan(planName);
    }
    let planRate = planParam === 'pro-weekly' ? '2' : planParam === 'pro-monthly' ? '4' : planParam === 'pro-yearly' ? '33' : planParam === 'lifetime' ? '99' : '0';

    if (user?.email && planParam) {
      axios.post(`${API_BASE_URL}/api/paypal-payment-success`, {
        emailId: user.email,
        plan: planName
      })
      .then(() => {
        console.log("✅ User upgraded successfully");
        localStorage.setItem("userUpgradedViaPaypal", "true");
        //trackdesk conversion tracking
        try {
          window.trackdesk("easyimagetotext", "conversion", {
            conversionType: "sale",
            currencyCode: "USD",
            amount: { value: planRate } 
          });
        } catch (e) {
          console.error("❌ Trackdesk paypal conversion trigger failed:", e);
        }
        //
      })
      .catch((err) => {
        console.error("❌ Upgrade failed:", err);
      });
    }
  }, [user]);

  return (
    <div className="mainDiv paypalPaymentSuccess">
      <div className="wrapper">
        <h2>✅ Payment Successful!</h2>
        <p>Thank you, <strong>{user?.name || user?.email}</strong>.</p>
        <p>You’ve upgraded to the <strong>{plan}</strong> plan.</p>
        {/* <p>Your premium access will be activated shortly after confirmation.</p> */}
        <p>In case of any queries, contact <span className="email">support@easyimagetotext.com</span>.</p>
      </div>
    </div>
  );
};

export default PaypalPaymentSuccess;
